import { format } from 'date-fns'

export function genFilename(
  attachment_index: number,
  ext: string,
  date_created = format(new Date(), 'dd-MM-yyyy'),
) {
  return `${date_created}_reimbursement_${attachment_index + 1}.${ext}`
}
